module.exports = __webpack_public_path__ + "static/img/jindian@3xenglish.5ede65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jindian@3xenglish.png
// module id = sb1I
// module chunks = 52